export default __webpack_public_path__ + "static/media/image 18.a460a746.png";